import gql from 'graphql-tag';

// Query all items from the menu assigned to this location, plus their existing availability windows
export const GET_AVAILABILITY_ITEMS = gql`
  query GetAvailabilityItems($locationId: uuid!) {
    item_availability_windows(where: { location_id: { _eq: $locationId } }) {
      id
      dish_id
      drink_id
      category_id
      day_of_week
      open_time
      close_time
    }
    menu_location_stock(where: { location_id: { _eq: $locationId } }) {
      id
      dish_id
      drink_id
      dish_item {
        id
        name
        order_index
        category_assignments {
          category_id
          category {
            id
            name
            order_index
          }
        }
      }
      drink_item {
        id
        name
        order_index
        category_assignments {
          category_id
          category {
            id
            name
            order_index
          }
        }
      }
    }
  }
`;

export const INSERT_AVAILABILITY_WINDOW = gql`
  mutation InsertAvailabilityWindow(
    $location_id: uuid!
    $organisation_id: uuid!
    $dish_id: uuid
    $drink_id: uuid
    $category_id: uuid
    $day_of_week: String!
    $open_time: timetz!
    $close_time: timetz!
  ) {
    insert_item_availability_windows_one(
      object: {
        location_id: $location_id
        organisation_id: $organisation_id
        dish_id: $dish_id
        drink_id: $drink_id
        category_id: $category_id
        day_of_week: $day_of_week
        open_time: $open_time
        close_time: $close_time
      }
    ) {
      id
    }
  }
`;

export const DELETE_AVAILABILITY_WINDOW = gql`
  mutation DeleteAvailabilityWindow($id: uuid!) {
    delete_item_availability_windows_by_pk(id: $id) {
      id
    }
  }
`;

export const DELETE_AVAILABILITY_WINDOWS_FOR_ITEM = gql`
  mutation DeleteAvailabilityWindowsForItem($location_id: uuid!, $dish_id: uuid, $drink_id: uuid, $category_id: uuid) {
    delete_item_availability_windows(
      where: {
        location_id: { _eq: $location_id }
        dish_id: { _eq: $dish_id }
        drink_id: { _eq: $drink_id }
        category_id: { _eq: $category_id }
      }
    ) {
      affected_rows
    }
  }
`;
